export const ENTER_GUESS = "ENTER_GUESS";
export const BUTTON_PRESS = "BUTTON_PRESS";
export const CHANGE_INPUT = "CHANGE_INPUT";
export const EVALUATE_STATS = "EVALUATE_STATS";
